const detectBrowser = (ua: string): string | undefined => {
  if (/Edg\//.test(ua)) return 'Edge'
  if (/OPR\//.test(ua)) return 'Opera'
  if (/Firefox\//.test(ua)) return 'Firefox'
  if (/Chrome\//.test(ua)) return 'Chrome'
  if (/Safari\//.test(ua)) return 'Safari'
  return undefined
}

const detectPlatform = (ua: string): string | undefined => {
  const uaData = (navigator as { userAgentData?: { platform?: string } }).userAgentData
  if (uaData?.platform) return uaData.platform
  if (/iPhone/.test(ua)) return 'iPhone'
  if (/iPad/.test(ua)) return 'iPad'
  if (/Android/.test(ua)) return 'Android'
  if (/Mac/.test(ua)) return 'macOS'
  if (/Windows/.test(ua)) return 'Windows'
  if (/Linux/.test(ua)) return 'Linux'
  return undefined
}

/**
 * Default label for a newly registered passkey, e.g. "Chrome (macOS)".
 * Returns '' when nothing can be detected — callers should fall back
 * to a translated default.
 */
export const getDefaultPasskeyName = (): string => {
  try {
    const ua = navigator.userAgent
    const browser = detectBrowser(ua)
    const platform = detectPlatform(ua)
    if (browser && platform) return `${browser} (${platform})`
    return browser || platform || ''
  } catch {
    return ''
  }
}
